import { isStringTrue } from "@iddataweb/idw-common-ui/utils";
import { UserRoleTypes } from "@enums/user-role-types";
import { AxnAdminUser } from "@idw-types/data/axn-admin-user";
import { AxnRelyingParty, FormattedAxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { AxnAdminUserRpProperty } from "@idw-types/data/axn-admin-user/axn-admin-user-rp-property";
import { UserPermissionTypes } from "@enums/user-permission-types";
import { RelyingParty } from "@idw-types/data/reference-data/generic";
import { IDWSession } from "@idw-types/data/idw-session";
import { RelyingPartyRole } from "@idw-types/common";

export const isAxnAdminUser = (user: AxnAdminUser) => {
    if (user) {
        const userProperties = user.axnAdminUserProperties || [];
        const organizationProperties = user.axnAdminUserOrganizationProperties || [];
        const rpProperties = user.axnAdminUserRPProperties || [];
        const roleTypes = Object.values(UserRoleTypes);

        const adminProperty = userProperties.find(property => property.propertyName === "admin");

        return (
            ![
                ...organizationProperties,
                ...rpProperties
            ].some(property => roleTypes.includes(property.propertyName as any)) &&
            adminProperty &&
            isStringTrue(adminProperty.propertyValue)
        );
    }
    return false;
};

export const extractRelyingPartiesForPropertyName = <T extends AxnRelyingParty | RelyingParty | FormattedAxnRelyingParty>(
    propertyName: UserPermissionTypes,
    axnAdminUserRPProperties: Array<AxnAdminUserRpProperty>,
    relyingParties: Array<T>
): Array<T> => {
    let allowedRelyingParties = relyingParties;

    if (axnAdminUserRPProperties.length > 0 && propertyName) {
        const allowedRelyingPartyIds = axnAdminUserRPProperties.filter(property =>
            property.propertyName === propertyName &&
            isStringTrue(property.propertyValue)
        ).map(property => property.relyingPartyID);

        allowedRelyingParties = allowedRelyingParties.filter(arp => allowedRelyingPartyIds.includes(arp.id));
    }

    return allowedRelyingParties;
};

export const getRelyingPartyRolesWithPermissions = (
    session: IDWSession,
    userId: string,
    axnRelyingParties: Array<AxnRelyingParty>,
    relyingPartyRoles: Array<RelyingPartyRole>
) => {
    const sessionUserListRelyingPartyIds = extractRelyingPartiesForPropertyName(
        UserPermissionTypes.LIST_USERS,
        session.user.axnAdminUserRPProperties,
        axnRelyingParties
    ).map(rp => rp.id);

    const sessionUserModifyRelyingPartyIds = extractRelyingPartiesForPropertyName(
        UserPermissionTypes.MODIFY_USERS,
        session.user.axnAdminUserRPProperties,
        axnRelyingParties
    ).map(rp => rp.id);

    return relyingPartyRoles.map(rpr => ({
        relyingPartyRole: rpr,
        canView: session.user.id === userId || sessionUserListRelyingPartyIds.includes(rpr.relyingParty.id),
        canModify: sessionUserModifyRelyingPartyIds.includes(rpr.relyingParty.id)
    }));
};